import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {choose} from 'lit/directives/choose.js';
import {when} from 'lit/directives/when.js';
import {customElement} from 'lit/decorators/custom-element.js';
import store from '../../store';
import {conditional} from '../../util/conditional';
import {luminaryOptions} from '../../sectionConfig';
import {getProductData} from '../../util/getProductData';
import {pimText, pimTextDebug} from '../../util/values';
import {selectProductModelId} from '../../selectors';

@customElement('shared-technical-data-page')
export class SharedTechnicalDataPage extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				margin: 0 var(--specsheet-large-gap) var(--specsheet-medium-gap) var(--specsheet-large-gap);
			}

			.technicalData {
				display: flex;
				justify-content: space-between;
				width: 100%;
				padding-top: var(--specsheet-medium-gap);
			}

			.drawing {
				width: 35%
			}

			.dataList {
				width: 65%;
			}

			.imageContainer {
				text-align: center;
				width: 75%;
				height: 80%;
				max-height: 800px;
				margin-left: 0;
				margin-right: auto;
			}

			img {
				max-width: 100%;
			}

			.avanza.imageContainer {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: left;
				width: 100%;
				height: 95%;
				max-height: 870px;
				margin-left: auto;
				margin-right: auto;
			}

			.avanzaImage {
				max-width: 100%;
			}


			@media print {
				:host {
					margin: 0;
				}

				.drawing {
					width: 30%;
				}

				.dataList {
					width: 70%;
				}

				img {
					max-width: 100%;
				}
			}
		`]
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.featuremodel = state.featureModel;
		this.productData = state.productData;
		this.status = state.status;
		this.lang = state.status.lang;
		this.lightProfile = state.lightProfile.data;
		this.decisions = state.decisions.data;
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}

	getValueFromProductData(featureId, featureValueId) {
		const pd = getProductData(featureId, this.productData);
		return pd?.values?.find(val => val.valueId === featureValueId);
	}

	t(featureId, context, value, prefix, suffix) {
		return this.debug ?
			pimTextDebug(this.lang, featureId, context, this.state.decisions.data, this.state.productData.translations, value, prefix, suffix) :
			pimText(this.lang, featureId, context, this.state.decisions.data, this.state.productData.translations, value, prefix, suffix);
	}

	c(id) {
		return conditional(this.decisions, this.conditionalVariantValues, id);
	}

	render() {
		const s = this.state;
		const lmo = luminaryOptions.find(luminaryOption => luminaryOption.id === this.lightProfile.project.luminary);
		let image = '';
		if (lmo && lmo.hasOwnProperty('imageModelSpecific')) {
			image = lmo.imageModelSpecific[selectProductModelId(s)].imageWhite;
		} else {
			image = lmo ? lmo.imageWhite : '';
		}
		return html`
			<div class="technicalData">

				<div class="drawing">
					<div class="imageContainer">
						${choose(
							this.status.family, [
								[
									'LightProfile',
									() => html`<img src="${image}"/>`
								],
								[
									'TheLine',
									() => html`
										<line-drawing></line-drawing>`
								], [
									'Aeto',
									() => html`
										<svg-aeto></svg-aeto>`
								]
							],
							() => html`
								${when(this.c('REDTAB.RETURN_LU_Image') && this.c('REDTAB.RETURN_LU_Image') !== '', () => html`
									<img class="avanzaImage" alt="product image" src="${this.c('REDTAB.RETURN_LU_Image')}"/>
								`)}
							`)
						}
					</div>
				</div>

				<div class="dataList">
					${choose(this.status.family, [
							[
								'Aeto',
								() => html`
									<solar-technical-data></solar-technical-data>`
							]
						],
						() => html`
							<shared-technical-data></shared-technical-data>`)
					}
		`;
	}
}
